export default {
    language: 'English',
}